import React from 'react'

const AlertMessage = (props) => {
    const {type, title, sub_title, border_type} = props;
    return (
        <>
            <div className={`alert alert-${type} d-flex align-items-center border border-${type} border-1 ${border_type === 'dashed' ? 'border-dashed' : ''} `}>
                <div className={`d-flex flex-column`}>
                    <h4 className={`mb-1 text-${type} fs-3`}>
                        {title && title}
                    </h4>
                    <span>
                        {sub_title && sub_title}
                    </span>
                </div>
            </div>
        </>
    )
}

export default AlertMessage